import { IObservable, Subject } from '~/rage/utils';
import { RockPaperScissorsChoice, RockPaperScissorsGameStatus } from '~/shared';
import { IRockPaperScissorsService } from './rockPaperScissorsTypes';

export class RockPaperScissorsStub implements IRockPaperScissorsService {
	private status = new Subject<RockPaperScissorsGameStatus>(
		RockPaperScissorsGameStatus.WAITING,
	);
	private opponentName = new Subject<string>('Allov Xam');
	private opponentChoice = new Subject<RockPaperScissorsChoice>(
		RockPaperScissorsChoice.ROCK,
	);
	private timer = new Subject<number>(10_000);

	public getTimer(): IObservable<number> {
		return this.timer;
	}

	public getStatus(): IObservable<RockPaperScissorsGameStatus> {
		return this.status;
	}

	public getOpponentName(): IObservable<string> {
		return this.opponentName;
	}

	public getOpponentChoice(): IObservable<RockPaperScissorsChoice> {
		return this.opponentChoice;
	}

	public async makeChoice(choice: RockPaperScissorsChoice): Promise<void> {
		console.log('rockPaperScissors: makeChoice', choice);
		setTimeout(() => {
			const opponentChoice = this.opponentChoice.getValue();
			if (choice === opponentChoice) {
				this.status.next(RockPaperScissorsGameStatus.DRAW);
			} else if (
				(choice === RockPaperScissorsChoice.ROCK &&
					opponentChoice === RockPaperScissorsChoice.SCISSORS) ||
				(choice === RockPaperScissorsChoice.PAPER &&
					opponentChoice === RockPaperScissorsChoice.ROCK) ||
				(choice === RockPaperScissorsChoice.SCISSORS &&
					opponentChoice === RockPaperScissorsChoice.PAPER)
			) {
				this.status.next(RockPaperScissorsGameStatus.WON);
			} else {
				this.status.next(RockPaperScissorsGameStatus.LOST);
			}
		}, 2000);
	}

	public async cancelOffer(): Promise<void> {
		console.log('rockPaperScissors: cancelOffer');
	}

	public async exit(): Promise<void> {
		console.log('rockPaperScissorsService: exit');
	}
}
